import React from 'react';
import { MessageBubble } from '../chat';
import type { DirectMessage } from '../../store/messageStore';

interface DirectMessageBubbleProps {
  directMessage: DirectMessage;
  currentUserId?: string; // Optional since MessageBubble determines this internally
  isGrouped?: boolean;
  isGroupLeader?: boolean;
}

const DirectMessageBubble: React.FC<DirectMessageBubbleProps> = ({ 
  directMessage,
  isGrouped = false,
  isGroupLeader = true
}) => {
  // Transform DirectMessage to match ChatMessage interface expected by MessageBubble
  const chatMessage = {
    id: directMessage.id,
    content: directMessage.message,
    type: 'text' as const,
    messageType: directMessage.messageType,
    gifUrl: directMessage.gifUrl || null,
    gifId: directMessage.gifId || null,
    groupId: '', // Not used in direct messages
    userId: directMessage.senderId,
    username: directMessage.sender.username,
    userProfilePhoto: directMessage.sender.profilePhoto,
    userSuspendedAt: directMessage.sender.suspendedAt,
    createdAt: directMessage.sentAt,
  };

  // Note: MessageBubble determines isOwnMessage internally using the userId in the message

  return (
    <MessageBubble 
      message={chatMessage} 
      isGrouped={isGrouped}
      isGroupLeader={isGroupLeader}
    />
  );
};

export default DirectMessageBubble;